"use client";

import { useEffect, useState } from "react";
import Loading from "@/app/components/Loading";
import { useGateHold } from "@/app/components/Gate";
import CraftQuiz, { CraftView } from "./CraftQuiz";
import { CRAFT_CSS } from "./craftStyle";

const WORLD = "Baunheim";

/**
 * 作製の一時画面。進行の画面から、作製中に入力シートのバーを押して開く。
 * 問いに 1 つずつ答え、終わると出来が出る。データは /api/play/craft と craft_answer から取る
 */
export default function PlayCraft({ region, slug, onExit }: { region: string; slug: string; onExit: () => void }) {
  const [view, setView] = useState<CraftView | null>(null);
  const [feel, setFeel] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  // 作製の中身を読み終えるまで、ロード画面に待ってもらう
  useGateHold(view === null && message === "");

  useEffect(() => {
    let alive = true;
    fetch(`/api/play/craft?world=${WORLD}&region=${encodeURIComponent(region)}&slug=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const body = await response.json();
        if (!alive) return;
        if (response.ok) setView(body.craft as CraftView);
        else setMessage(body.error ?? "作製を読めません");
      })
      .catch(() => {
        if (alive) setMessage("サーバーに繋がりません");
      });
    return () => {
      alive = false;
    };
  }, [region, slug]);

  const answer = async (choice: number) => {
    if (busy) return;
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/play/craft_answer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ world: WORLD, region, slug, choice }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.error ?? "答えを送れません");
      setView(body.craft as CraftView);
      setFeel(body.feel ?? "");
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "答えを送れません");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cf-root">
      <style dangerouslySetInnerHTML={{ __html: CRAFT_CSS }} />
      <div className="cf-app">
        <header className="cf-head">
          <h2>作製</h2>
          {view && !view.result ? (
            <button type="button" className="cf-head-btn" onClick={onExit}>
              物語へ戻る
            </button>
          ) : null}
        </header>
        <div className="cf-body">
          {view ? <CraftQuiz view={view} feel={feel} busy={busy} onAnswer={answer} /> : message ? <p>{message}</p> : <Loading label="作製を読んでいます" />}
          {message && view ? <p className="cf-message">{message}</p> : null}
        </div>
        {!view || view.result ? (
          <div className="cf-foot">
            <button type="button" className="cf-main-btn" onClick={onExit}>
              物語へ戻る
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
